import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FP_ROUTES, HAS_GEF, HAS_GESTION_STOCKS, HAS_VARIATIONS_STOCKS, STOCKS_FEATURES} from "../core/constants";
import {Auth2Guard} from "../core/services/security/auth2.guard";
import {StocksComponent} from "./stocks/stocks.component";
import {InventaireComponent} from "./stocks/inventaire/inventaire.component";
import {GestionStocksRootComponent} from "./gestion-stocks-root.component";
import {StocksResolverService} from "./stocks/stocks-resolver.service";
import {MatieresPremieresComponent} from "./stocks/matieres-premieres/matieres-premieres.component";
import {MouvementsComponent} from "./mouvements/mouvements.component";
import {GrilleMouvementsComponent} from "./mouvements/grille-mouvements/grille-mouvements.component";
import {StockMinimumComponent} from "./stocks/stock-minimum/stock-minimum.component";
import {HistoriqueInventaireComponent} from "./historique-inventaire/historique-inventaire.component";
import {ValidationInventaireComponent} from "./validation-inventaire/validation-inventaire.component";
import {VariationsStocksComponent} from "./variations-stocks/variations-stocks.component";


const routes: Routes = [

  {
    path: FP_ROUTES.GESTION_STOCKS,
    component: GestionStocksRootComponent,
    canActivate: [Auth2Guard],
    canActivateChild: [Auth2Guard],
    runGuardsAndResolvers: 'always',
    data: {
      roles: [HAS_GESTION_STOCKS, HAS_VARIATIONS_STOCKS],
      permission: 'OR'
    },
    children: [
      {
        path: STOCKS_FEATURES.HISTORIQUE_INVENTAIRE,
        component: HistoriqueInventaireComponent,
        data: {roles: [HAS_GESTION_STOCKS]}
      },
      {
        path: STOCKS_FEATURES.VALIDATION_INVENTAIRE,
        component: ValidationInventaireComponent,
        data: {roles: [HAS_GESTION_STOCKS]}
      },
      {
        path: STOCKS_FEATURES.VARIATIONS_STOCKS,
        component: VariationsStocksComponent,
        data: {roles: [HAS_GESTION_STOCKS, HAS_VARIATIONS_STOCKS], permission: 'OR'}
      },
      {
        path: STOCKS_FEATURES.MOUVEMENTS,
        component: MouvementsComponent,
        data: {
          roles: [HAS_GESTION_STOCKS]
        },
        resolve: {
          stocksSupplier: StocksResolverService
        },
        children: [
          {
            path: 'grille-mouvements',
            runGuardsAndResolvers: 'always',
            component: GrilleMouvementsComponent,
            data: {
              roles: [HAS_GESTION_STOCKS]
            },
          },
        ]
      },
      {
        path: 'stocks',
        component: StocksComponent,
        data: {
          roles: [HAS_GESTION_STOCKS]
        },
        resolve: {
          stocksSupplier: StocksResolverService
        },
        children: [
          {
            path: STOCKS_FEATURES.INVENTAIRE,
            runGuardsAndResolvers: 'always',
            component: InventaireComponent,
            data: {
              roles: [HAS_GESTION_STOCKS]
            },
          },
          {
            path: STOCKS_FEATURES.MATIERES_PREMIERES,
            runGuardsAndResolvers: 'always',
            component: MatieresPremieresComponent,
            data: {
              roles: [HAS_GESTION_STOCKS]
            },
          },
          {
            path: STOCKS_FEATURES.STOCKS_MINIMUM,
            runGuardsAndResolvers: 'always',
            component: StockMinimumComponent,
            data: {roles: [HAS_GESTION_STOCKS]},
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestionStocksRoutingModule {
}
